import React, { useEffect, useState } from 'react';
import { Product } from '../../../models/shop.model';
import { shopPublicService } from '../../../services/shop-public.service';
import { useShopStore } from '../../../redux/shop/facade';
import { useStorefrontBranding } from '../../../redux/branding/facade';
import { StorefrontListingComponent } from '../components/storefront-listing.component';

export const StorefrontListingContainer: React.FC = () => {
    const [products, setProducts] = useState<Product[]>([]);
    const [isFetching, setIsFetching] = useState(true);
    const [hasFetched, setHasFetched] = useState(false);

    const { addToCart, cartCount } = useShopStore();
    const { currencyPrefix } = useStorefrontBranding();

    useEffect(() => {
        let cancelled = false;
        setIsFetching(true);
        shopPublicService
            .getProducts()
            .then((response) => {
                if (!cancelled) {
                    setProducts(response.results.products);
                    setHasFetched(true);
                    setIsFetching(false);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setHasFetched(true);
                    setIsFetching(false);
                }
            });
        return () => {
            cancelled = true;
        };
    }, []);

    const handleAddToCart = (product: Product, learnerId: number | null) => {
        const id = `${product.productKey}:${learnerId ?? 'guest'}`;
        addToCart({
            id,
            type: product.type,
            productId: product.packageId,
            packageId: product.packageId,
            eventPackageId: product.eventPackageId ?? null,
            shoppableType: product.shoppableType,
            shoppableId: product.shoppableId,
            product,
            learnerId,
            quantity: 1,
            itemId: product.itemId ?? null,
        });
    };

    return (
        <StorefrontListingComponent
            products={products}
            isFetching={isFetching}
            hasFetched={hasFetched}
            cartCount={cartCount}
            currencyPrefix={currencyPrefix}
            onAddToCart={handleAddToCart}
        />
    );
};
